import type { SidebarState } from './types';
import { ReduxState } from 'app/redux/types';

import { Tab } from './constants';

// ---

export const selectSidebarState = (state: ReduxState): SidebarState => {
  return state.sidebar;
};

export const selectActiveTab = (state: ReduxState): Tab => {
  return selectSidebarState(state).activeTab;
};

export const selectToAllowRefreshWarning = (state: ReduxState): boolean => {
  return selectSidebarState(state).allowRefreshWarning;
};
